// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__21XZ9","header":"ReportDetails_header__TCpCN","title":"ReportDetails_title__NFzDe","left":"ReportDetails_left__XOai8"};